const callForContentConfig = {
  proposalsCapNumber: 6,

  SAVING_STATE: {
    DRAFT: 'DRAFT',
    SUBMIT: 'SUBMIT',
  },
}

export default callForContentConfig
